<template>
    <div class="mb-5 mb-xl-8 card">
        <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1">{{ $t("pages.usersList.title") }}</span>
                <span class="text-muted mt-1 fw-bold fs-7">{{ this.$store.getters.currentSettings.clientName }}</span>
            </h3>
            <div class="align-items-end flex-column">
                <a href="#" class="btn btn-primary btn-light" @click="resendUserInvitation()">Relancer les invitations</a>
            </div>
        </div>
        <div class="card-body py-3">
            <div class="p-5 mt-5 mb-5 bg-primary bg-opacity-25 rounded">
                <div class="row">
                    <div class="col">
                        <input
                            v-model="filter.identity"
                            type="text"
                            name="fname"
                            class="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                            :placeholder="$t('pages.users.name')"
                        />
                    </div>
                    <!--end::Col-->

                    <!--begin::Col-->
                    <div class="col">
                        <input v-model="filter.email" type="text" name="lname" class="form-control form-control-lg form-control-solid" :placeholder="$t('pages.users.email')" />
                    </div>
                    <div class="col">
                        <select v-model="filter.user_type" class="form-control form-control-solid">
                            <option disabled selected value>{{ $t("pages.users.userType") }}</option>
                            <option name="pilote" value="pilote">Pilote</option>
                            <option name="network" value="network">Réseau baromètre</option>
                            <option name="manager" value="manager">Manager</option>
                        </select>
                    </div>
                    <div class="col">
                        <select v-model="filter.status" class="form-control form-control-solid">
                            <option disabled selected value>{{ $t("pages.users.status") }}</option>
                            <option name="active" value="ACT">{{ $t("pages.users.active") }}</option>
                            <option name="disabled" value="DIS">{{ $t("pages.users.disabled") }}</option>
                            <option name="disabled" value="INV">{{ $t("pages.users.invited") }}</option>
                        </select>
                    </div>
                    <div class="col">
                        <button type="submit" class="btn btn-primary btn-light btn-active-light-primary" @click="fetchUsers()">
                            {{ $t("general.search") }}
                        </button>
                        <button type="submit" class="ms-3 btn btn-icon btn-light btn-active-light-primary" @click="resetFilter()">
                            <i class="fas fa-redo fs-7 pt-1"></i>
                        </button>
                    </div>
                    <!--end::Col-->
                </div>
                <!--end::Row-->
            </div>
            <!--end::Col-->

            <div class="table-responsive">
                <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                    <thead>
                        <tr class="fw-bolder text-muted">
                            <th class="min-w-150px">{{ $t("pages.usersList.name") }}</th>
                            <th class="min-w-120px">{{ $t("pages.usersList.email") }}</th>
                            <th class="min-w-120px">{{ $t("pages.usersList.accessLevel") }}</th>
                            <th class="min-w-120px">{{ $t("pages.usersList.perimeter") }}</th>
                            <th class="min-w-120px">{{ $t("pages.usersList.lastConnection") }}</th>
                            <th class="min-w-120px">{{ $t("pages.usersList.status") }}</th>
                            <th class="min-w-100px text-end">{{ $t("pages.usersList.actions") }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <tr v-for="user in this.users" v-bind:key="user.id">
                            <td>
                                <a href="#" class="text-dark fw-bolder text-hover-primary fs-6">{{ user.userprofile.lastname }}</a>
                                <span class="text-muted fw-bold text-muted d-block fs-7">{{ user.userprofile.firstname }}</span>
                            </td>
                            <td>
                                <a href="#" class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"> {{ user.email }}</a>
                            </td>
                            <td>
                                <span class="badge-light badge text-primary">{{ user.userprofile.user_type.label }}</span>
                            </td>
                            <td>
                                <span class="badge-light badge text-primary">
                                    <i class="fas fa-sitemap fs-5 me-2"></i>
                                    {{ user.userprofile.related_companies[0].name }}
                                </span>
                            </td>
                            <td>
                                <a href="#" class="text-dark fw-bolder text-hover-primary d-block mb-1 fs-6">11/02/2021</a>
                                <span class="text-muted fw-bold text-muted d-block fs-7">16h37</span>
                            </td>
                            <td>
                                <span v-if="user.status === 'ACT'" class="badge-light-success badge text-success">Actif</span>
                                <span v-if="user.status === 'INV'" class="badge-light-primary badge text-primary">Invité</span>
                            </td>
                            <td class="text-end">
                                <a @click="editUser(user)" href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                                    <span class="svg-icon svg-icon-3"
                                        ><svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.3"
                                                d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                                fill="black"
                                            ></path></svg></span></a
                                ><a href="#" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                    ><span class="svg-icon svg-icon-3"
                                        ><svg fill="none" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.5"
                                                d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                                fill="black"
                                            ></path>
                                            <path
                                                xmlns="http://www.w3.org/2000/svg"
                                                opacity="0.5"
                                                d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                                fill="black"
                                            ></path></svg></span
                                ></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="loading">
                    <div class="d-flex row-auto flex-center w-100 h-200px">
                        <span class="spinner-border text-primary" role="status"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import userApi from "@/core/services/User";
import { useI18n } from "vue-i18n";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useRouter } from "vue-router";

export default defineComponent({
    name: "administration-users",
    components: {},
    data() {
        return {
            name: "",
            users: [],
            filter: {
                identity: "",
                email: "",
                user_type: "",
                status: "",
            },
            loading: true,
        };
    },
    methods: {
        resendUserInvitation() {
            userApi.resendUserInvitation().then((response) => {
                Swal.fire({
                    text: response.data.user_count + " utilisateurs ont de nouveau reçu leur invitation",
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Fermer",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-success",
                    },
                });
            });
        },
        resetFilter() {
            this.filter = {
                identity: "",
                email: "",
                user_type: "",
                status: "",
            };
            this.fetchUsers();
        },
        fetchUsers() {
            this.loading = true;
            userApi
                .getUsers(this.filter)
                .then((response) => {
                    this.users = response.data["users"];
                    this.loading = false;
                })
                .catch(() => {
                    this.displayErrorMsg("Une erreur est survenue lors de la récupération des utilisateurs.");
                });
        },
        displayErrorMsg(msg: string) {
            Swal.fire({
                text: msg,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Fermer",
                customClass: {
                    confirmButton: "btn fw-bold btn-light-danger",
                },
            });
        },
    },
    setup() {
        const { t } = useI18n();
        const router = useRouter();
        setCurrentPageBreadcrumbs(t("pages.dashboard.users"), []);

        function editUser(user: any) {
            userApi.getSpecificUser(user.id).then((response) => {
                router.push({ name: "usersdetail", params: { user_id: user.id }, query: { admin: "true" } });
            });
        }

        return { t, editUser };
    },
    watch: {
        "$i18n.locale": function () {
            setCurrentPageBreadcrumbs(this.t("pages.dashboard.users"), []);
        },
    },
    created() {
        this.fetchUsers();
    },
});
</script>
